import script from "./AutoAIAgentMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIAgentMessages.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIAgentMessages.vue?vue&type=style&index=0&id=10c704e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c704e2"]])

export default __exports__